import type { CSSProperties, SVGProps } from 'react'
import { createElement } from 'react'

// SVG elements are now plain components with inline styles
// The components below replace the old styled API usage

/**
 * @deprecated Use the styled components directly instead of classes
 * This is only kept for backward compatibility with existing code
 */
export default () => ({
  classes: {
    root: 'root',
    label: 'rendererLabel',
    badge: 'rendererBadge',
    marker: 'rendererMarker',
    markerText: 'rendererMarkerText',
    loop: 'rendererLoop',
    loopHandle: 'rendererLoopHandle',
  },
})

const labelTextStyle: CSSProperties = {
  fontSize: 10,
  userSelect: 'none',
}

export const LabelText = (props: SVGProps<SVGTextElement>) =>
  createElement('text', { ...props, style: { ...labelTextStyle, ...props.style } })

const badgeStyle: CSSProperties = {
  fontSize: 10,
  color: 'var(--tuna-palette-primary-contrastText)',
  backgroundColor: 'var(--tuna-palette-primary-main)',
}

export const Badge = (props: SVGProps<SVGTextElement>) =>
  createElement('text', { ...props, style: { ...badgeStyle, ...props.style } })

const markerStyle: CSSProperties = {
  cursor: 'pointer',
}

export const Marker = (props: SVGProps<SVGGElement>) =>
  createElement('g', { ...props, style: { ...markerStyle, ...props.style } })

const markerTextStyle: CSSProperties = {
  color: 'var(--tuna-palette-primary-contrastText)',
  fontSize: 10,
  userSelect: 'none',
}

export const MarkerText = (props: SVGProps<SVGTextElement>) =>
  createElement('text', { ...props, style: { ...markerTextStyle, ...props.style } })

const loopStyle: CSSProperties = {
  cursor: 'pointer',
}

export const Loop = (props: SVGProps<SVGGElement>) =>
  createElement('g', { ...props, style: { ...loopStyle, ...props.style } })

const loopBodyStyle: CSSProperties = {
  cursor: 'grab',
}

export const LoopBody = (props: SVGProps<SVGRectElement>) =>
  createElement('rect', { ...props, style: { ...loopBodyStyle, ...props.style } })

const loopHandleStyle: CSSProperties = {
  cursor: 'ew-resize',
}

export const LoopHandleLeft = ({ as: Tag = 'rect', ...props }: SVGProps<SVGRectElement> & { as?: string }) =>
  createElement(Tag, { ...props, style: { ...loopHandleStyle, ...props.style } })

export const LoopHandleRight = ({ as: Tag = 'rect', ...props }: SVGProps<SVGRectElement> & { as?: string }) =>
  createElement(Tag, { ...props, style: { ...loopHandleStyle, ...props.style } })
